export default {
  tCodeOptions: []
};